import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { announcementsAPI } from '../../services/api';
import { Megaphone, Calendar, FileText, Eye } from 'lucide-react';

const CustodianAnnouncements = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const resp = await announcementsAPI.getAnnouncements({ limit: 20 });
                setItems(resp?.data?.data?.announcements || resp?.data?.announcements || []);
            } catch (e) {
                console.error('Failed to load announcements', e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
                <div className="flex items-center justify-between">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">Announcements</h1>
                        <p className="text-sm text-secondary-600 mt-1">See bond announcements created by issuer or trustee</p>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body p-0">
                        {loading ? (
                            <div className="p-8 text-center">Loading...</div>
                        ) : items.length === 0 ? (
                            <div className="text-center p-12 text-secondary-600">No announcements</div>
                        ) : (
                            <div className="overflow-x-auto">
                                <table className="table w-full">
                                    <thead className="table-header">
                                        <tr>
                                            <th className="table-header-cell" style={{ width: '75%' }}>Announcement</th>
                                            <th className="table-header-cell" style={{ width: '25%' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-body">
                                        {items.map(a => (
                                            <tr key={a._id} className="table-row">
                                                <td className="table-cell align-top" style={{ maxWidth: '0', width: '90%' }}>
                                                    <div className="pr-4 overflow-hidden">
                                                        <div className="flex items-center space-x-2 mb-2">
                                                            <Megaphone className="w-4 h-4 text-primary-600 flex-shrink-0" />
                                                            <Link to={`/custodian/announcements/${a._id || a.id}`} className="font-medium text-primary-700 hover:underline truncate block flex-1 min-w-0">{a.title}</Link>
                                                        </div>
                                                        <div className="text-sm text-secondary-500 flex items-center space-x-4 mb-2 flex-wrap">
                                                            <span className="inline-flex items-center"><FileText className="w-3 h-3 mr-1" />{a.bondId?.bondName || '—'}</span>
                                                            <span className="inline-flex items-center"><Calendar className="w-3 h-3 mr-1" />{new Date(a.publishedAt || a.createdAt).toLocaleDateString()}</span>
                                                        </div>
                                                        <p className="text-dark-gray line-clamp-2 break-words overflow-hidden">{a.content}</p>
                                                    </div>
                                                </td>
                                                <td className="table-cell align-center" style={{ width: '10%' }}>
                                                    <button
                                                        onClick={() => navigate(`/custodian/announcements/${a._id || a.id}`)}
                                                        className="text-primary-600 hover:text-primary-700 transition-colors"
                                                        title="View Details"
                                                    >
                                                        <Eye className="w-4 h-4" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustodianAnnouncements;
